<div *ngIf="dados" class="document-preview">
  <!-- Cabeçalho com logos -->
  <table style="border:none;width:100%;margin-bottom:4px;" cellpadding="0" cellspacing="0">
    <tr style="border:none;">
      <td style="border:none;width:75px;vertical-align:top;text-align:center;">
        <img src="assets/img/logo_unicamp.png" style="width:75px;height:83px;" alt="Unicamp">
      </td>
      <td style="border:none;text-align:center;vertical-align:middle;padding:0 16px;">
      </td>
      <td style="border:none;width:75px;vertical-align:top;text-align:center;">
        <img *ngIf="logoUnidadePreview" [src]="logoUnidadePreview" style="width:75px;height:83px;" alt="Unidade">
        <label *ngIf="!logoUnidadePreview" class="upload-logo-placeholder">
          <span>＋</span>
          <span>Logo da<br/>Unidade</span>
          <input type="file" accept="image/*" (change)="onLogoUpload($event)" hidden>
        </label>
      </td>
    </tr>
  </table>

  <h2 class="doc-center">UNIVERSIDADE ESTADUAL DE CAMPINAS</h2>
  <h3 class="doc-center">{{ dados.dadosConcurso.nomeUnidade }}</h3>

  <!-- Dados do concurso -->
  <p>
    <strong>{{ tituloDocumento }}</strong><br/>
    <strong>Proc. nº (SIGAD):</strong> {{ dados.dadosConcurso.processoSigad }}<br/>
    <strong>Área:</strong> {{ dados.dadosConcurso.area }}<br/>
    <strong>Disciplina(s):</strong> {{ dados.dadosConcurso.disciplinas }}<br/>
    <strong>Departamento:</strong> {{ dados.dadosConcurso.departamento }}<br/>
    <strong>Comissão Julgadora:</strong>
    <ng-container *ngFor="let m of dados.comissao; let last = last">{{ m.nome }}<span *ngIf="m.presidente"> - Presidente</span><span *ngIf="!last">, </span></ng-container>.
  </p>

  <!-- Parágrafo de abertura (tipo-específico) -->
  <ng-container [ngSwitch]="tipoProva">

    <!-- PROVA ESCRITA -->
    <ng-container *ngSwitchCase="'ATA_PROVA_ESCRITA'">
      <p>
        <mat-form-field appearance="outline" class="inline-field-lg">
          <mat-label>Data e hora da reunião</mat-label>
          <input matInput [(ngModel)]="campos['dataHoraReuniao']" (ngModelChange)="emitir()" placeholder="Aos ___ dias do mês de ___ do ano de ___, às ___ horas e ___ minutos">
        </mat-form-field>, reuniu-se a Comissão Julgadora do Concurso Público em epígrafe para elaboração da Ata da Prova Escrita, realizada em
        <mat-form-field appearance="outline" class="inline-field">
          <mat-label>Data da prova</mat-label>
          <input matInput [(ngModel)]="campos['dataRealizacaoProva']" (ngModelChange)="emitir()" mask="00/00/0000" [dropSpecialCharacters]="false" placeholder="dd/mm/aaaa">
        </mat-form-field>. {{ candidatosPresentes.length > 1 ? 'Submeteram-se' : 'Submeteu-se' }} à prova {{ candidatosPresentes.length > 1 ? 'os candidatos presentes' : 'o candidato presente' }}:
        <span *ngFor="let c of candidatosPresentes; let last = last">{{ c.nome | uppercase }}<span *ngIf="!last">, </span></span>.
      </p>

      <p *ngIf="candidatosAusentes.length > 0">{{ candidatosAusentes.length > 1 ? 'Deixaram' : 'Deixou' }} de comparecer {{ candidatosAusentes.length > 1 ? 'os candidatos' : 'o candidato' }}: <span *ngFor="let c of candidatosAusentes; let last = last">{{ c.nome | uppercase }}<span *ngIf="!last">, </span></span>, {{ candidatosAusentes.length > 1 ? 'os quais ficam eliminados' : 'o qual fica eliminado' }} do Concurso.</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Professor(es) presente(s) na realização da prova</mat-label>
        <textarea matInput rows="2" cdkTextareaAutosize [(ngModel)]="campos['professoresPresentes']" (ngModelChange)="emitir()" placeholder="Nome(s) do(s) professor(es) que esteve(estiveram) presente(s)"></textarea>
      </mat-form-field>

      <p>Inicialmente, o(a) Senhor(a) Presidente da Comissão Julgadora informou aos candidatos que o resultado oficial será divulgado no endereço eletrônico <em>inscricoes.unicamp.br</em>. Na sequência, prestou os esclarecimentos necessários sobre a Prova Escrita, em conformidade com o Edital de Abertura, a Deliberação CONSU-A-04/2025 e a Deliberação CEPE-A-<mat-form-field appearance="outline" class="inline-field-sm">
          <mat-label>nº/ano</mat-label>
          <input matInput [(ngModel)]="campos['deliberacaoCepe']" (ngModelChange)="emitir()">
        </mat-form-field>.</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Descrição do procedimento (instruções, anonimização, prazo de correção, etc.)</mat-label>
        <textarea matInput rows="5" cdkTextareaAutosize [(ngModel)]="campos['descricaoProcedimento']" (ngModelChange)="emitir()" placeholder="Descrever as instruções passadas aos candidatos, o procedimento para aplicação da prova, anonimização, inserção no sistema, prazo concedido aos membros da Comissão Julgadora para correção das provas, bem como qualquer outra intercorrência."></textarea>
      </mat-form-field>

      <p>Cada examinador atribuiu uma nota de 0 (zero) a 10 (dez), com Peso {{ campos['pesoProva'] }}, diretamente no Sistema de Gestão de Concursos da Unicamp, utilizando login e senha individuais, conforme o item 9.1.6 do Edital. Concluída a valoração, o(a) Presidente procedeu à consolidação dos resultados da Prova Escrita no Sistema de Gestão de Concursos da Unicamp, conforme tabela abaixo:</p>
    </ng-container>

    <!-- PLANO DE TRABALHO -->
    <ng-container *ngSwitchCase="'ATA_PLANO_TRABALHO'">
      <p>
        <mat-form-field appearance="outline" class="inline-field-lg">
          <mat-label>Data e hora da reunião</mat-label>
          <input matInput [(ngModel)]="campos['dataHoraReuniao']" (ngModelChange)="emitir()" placeholder="Aos ___ dias do mês de ___ do ano de ___, às ___ horas e ___ minutos">
        </mat-form-field>, de forma virtual, reuniu-se a Comissão Julgadora do Concurso Público em epígrafe, sob a presidência do(a) Prof(a). Dr(a). {{ presidente }}, para realização da ata da Prova de Análise do Plano de Trabalho.
      </p>

      <p>Foi concedido aos membros da referida Comissão o prazo regulamentar de
        <mat-form-field appearance="outline" class="inline-field-sm">
          <mat-label>Dias</mat-label>
          <input matInput [(ngModel)]="campos['prazoAnalise']" (ngModelChange)="emitir()">
        </mat-form-field> dia(s) para análise da documentação (Memorial e Plano de Trabalho) inserida pelos candidatos no Sistema de Gestão de Concursos da Unicamp por ocasião de suas inscrições.</p>

      <p>Com base nos critérios de julgamento definidos no Edital de Abertura, os examinadores atribuíram individualmente suas notas de 0 (zero) a 10 (dez), com Peso {{ campos['pesoProva'] }}, diretamente no Sistema de Gestão de Concursos da Unicamp, mediante login e senha individuais. A pontuação encontra-se consolidada abaixo:</p>
    </ng-container>

    <!-- PROVA DE TÍTULOS -->
    <ng-container *ngSwitchCase="'ATA_PROVA_TITULOS'">
      <p>
        <mat-form-field appearance="outline" class="inline-field-lg">
          <mat-label>Data e hora da reunião</mat-label>
          <input matInput [(ngModel)]="campos['dataHoraReuniao']" (ngModelChange)="emitir()" placeholder="Aos ___ dias do mês de ___ do ano de ___, às ___ horas e ___ minutos">
        </mat-form-field>, de forma virtual, reuniu-se a Comissão Julgadora do Concurso Público em epígrafe, sob a presidência do(a) Prof(a). Dr(a). {{ presidente }}, para realização da ata da Prova de Títulos.
      </p>

      <p>Foi concedido aos membros da referida Comissão o prazo regulamentar de
        <mat-form-field appearance="outline" class="inline-field-sm">
          <mat-label>Dias</mat-label>
          <input matInput [(ngModel)]="campos['prazoAnalise']" (ngModelChange)="emitir()">
        </mat-form-field> dia(s) para análise da documentação (Memorial e documentos comprobatórios) apresentada pelos candidatos no Sistema de Gestão de Concursos da Unicamp por ocasião de suas inscrições.</p>

      <p>Com base nos critérios de julgamento definidos no Edital de Abertura, os examinadores atribuíram individualmente suas notas de 0 (zero) a 10 (dez), com Peso {{ campos['pesoProva'] }}, diretamente no sistema, mediante login e senha individuais. A pontuação encontra-se consolidada abaixo:</p>
    </ng-container>

    <!-- PROVA DIDÁTICA -->
    <ng-container *ngSwitchCase="'ATA_PROVA_DIDATICA'">
      <p>
        <mat-form-field appearance="outline" class="inline-field-lg">
          <mat-label>Data e hora da reunião</mat-label>
          <input matInput [(ngModel)]="campos['dataHoraReuniao']" (ngModelChange)="emitir()" placeholder="Aos ___ dias do mês de ___ do ano de ___, às ___ horas e ___ minutos">
        </mat-form-field>, reuniu-se a Comissão Julgadora do Concurso Público em epígrafe, sob a presidência do(a) Prof(a). Dr(a). {{ presidente }}, para realização da Prova Didática.
      </p>

      <p>O(A) Presidente prestou as instruções aos candidatos relativas à duração da apresentação, recursos didáticos permitidos e critérios de avaliação.</p>

      <p>Esclarecidas todas as dúvidas, iniciou-se a Prova Didática, obedecendo à ordem do sorteio prévio de apresentação e temas, conforme detalhado a seguir:</p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Candidato(a) | Tema sorteado | Duração</mat-label>
        <textarea matInput rows="5" cdkTextareaAutosize [(ngModel)]="campos['descricaoProcedimento']" (ngModelChange)="emitir()" placeholder="Candidato(a) 1: [Nome] | Tema: [Ponto Sorteado] | Duração: ___ minutos.&#10;Candidato(a) 2: [Nome] | Tema: [Ponto Sorteado] | Duração: ___ minutos."></textarea>
      </mat-form-field>

      <p>Os membros da Comissão Julgadora avaliaram a execução das aulas respeitando os critérios estabelecidos no item 9.4.4 do Edital de Abertura. Concluídas as exposições, cada examinador atribuiu uma nota de 0 (zero) a 10 (dez), com Peso {{ campos['pesoProva'] }}, diretamente no Sistema de Gestão de Concursos da Unicamp, utilizando login e senha individuais.</p>
    </ng-container>

    <!-- PROVA DE ARGUIÇÃO -->
    <ng-container *ngSwitchCase="'ATA_PROVA_ARGUICAO'">
      <p>
        <mat-form-field appearance="outline" class="inline-field-lg">
          <mat-label>Data, hora e local da reunião</mat-label>
          <input matInput [(ngModel)]="campos['dataHoraReuniao']" (ngModelChange)="emitir()" placeholder="Aos ___ dias do mês de ___, às ___ horas, na sala/auditório">
        </mat-form-field>, reuniu-se a Comissão Julgadora do Concurso Público em epígrafe, sob a presidência do(a) Prof(a). Dr(a). {{ presidente }}, para realização da Prova de Arguição.
      </p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Descrição do procedimento adotado</mat-label>
        <textarea matInput rows="5" cdkTextareaAutosize [(ngModel)]="campos['descricaoProcedimento']" (ngModelChange)="emitir()" placeholder="Descrever como se deu a realização da Prova, nos termos do item 9.5 do Edital"></textarea>
      </mat-form-field>

      <p>Concluídas as arguições e respeitados os critérios de julgamento definidos no Edital de Abertura, cada examinador atribuiu uma nota de 0 (zero) a 10 (dez), com Peso {{ campos['pesoProva'] }}, diretamente no Sistema de Gestão de Concursos da Unicamp, utilizando login e senha individuais.</p>
    </ng-container>

    <!-- PROVA ESPECÍFICA -->
    <ng-container *ngSwitchCase="'ATA_PROVA_ESPECIFICA'">
      <p>
        <mat-form-field appearance="outline" class="inline-field-lg">
          <mat-label>Data, hora e local da reunião</mat-label>
          <input matInput [(ngModel)]="campos['dataHoraReuniao']" (ngModelChange)="emitir()" placeholder="Aos ___ dias do mês de ___, às ___ horas, na sala/auditório">
        </mat-form-field>, reuniu-se a Comissão Julgadora do Concurso Público em epígrafe, sob a presidência do(a) Prof(a). Dr(a). {{ presidente }}, para realização da Prova Específica – {{ campos['fase'] }}.
      </p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Descrição do procedimento adotado</mat-label>
        <textarea matInput rows="5" cdkTextareaAutosize [(ngModel)]="campos['descricaoProcedimento']" (ngModelChange)="emitir()" placeholder="Descrever como se deu a realização da Prova, nos termos do item 9.6 do Edital"></textarea>
      </mat-form-field>

      <p>Cada examinador atribuiu uma nota de 0 (zero) a 10 (dez), com Peso {{ campos['pesoProva'] }}, diretamente no Sistema de Gestão de Concursos da Unicamp, utilizando login e senha individuais, conforme o item 9.6.3 do Edital. Concluída a valoração, o(a) Presidente procedeu à consolidação dos resultados da Prova Específica no Sistema, conforme tabela abaixo:</p>
    </ng-container>

  </ng-container>

  <!-- Tabela de notas (comum a todas as atas) -->
  <table *ngIf="candidatosNotas.length > 0" class="equal-cols">
    <colgroup>
      <col style="width:30%">
      <col *ngFor="let ex of examinadores">
    </colgroup>
    <thead>
      <tr>
        <th rowspan="2">CANDIDATOS</th>
        <th [attr.colspan]="examinadores.length">COMISSÃO JULGADORA</th>
      </tr>
      <tr>
        <th *ngFor="let ex of examinadores">Prof(a). Dr(a). {{ ex }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cand of candidatosNotas">
        <td style="text-align:left">{{ cand | uppercase }}</td>
        <td *ngFor="let ex of examinadores">{{ getNota(cand, ex) }}</td>
      </tr>
    </tbody>
  </table>

  <!-- Intercorrências -->
  <p><strong>Intercorrências:</strong></p>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Relatar intercorrências</mat-label>
    <textarea matInput rows="2" cdkTextareaAutosize [(ngModel)]="campos['intercorrencias']" (ngModelChange)="emitir()" placeholder="Não houve intercorrências."></textarea>
  </mat-form-field>

  <!-- Fechamento -->
  <p>Nada mais havendo a tratar, lavrou-se a presente ata que segue assinada digitalmente pelos membros da Comissão Julgadora.</p>

  <div class="doc-footer">
    <p>Campinas,
      <mat-form-field appearance="outline" class="inline-field">
        <mat-label>Data</mat-label>
        <input matInput [(ngModel)]="campos['dataDocumento']" (ngModelChange)="emitir()" mask="00/00/0000" [dropSpecialCharacters]="false" placeholder="dd/mm/aaaa">
      </mat-form-field>.
    </p>
  </div>
</div>
